import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
import { useMountEffect } from "app/utils/hooks";
import "./Credentials.scss";
import DriversLicense from "../DriversLicense/DriversLicense";
import TWICCard from "../TWICCard/TWICCard";
import Passport from "../Passport/Passport";
import Information from "../../ProfileDetails/Information/Information";

const Credentials = () => {
  const expirationHeaders = {
    typeOfEExpirations: "Type of Expirations",
    idNumber: "Id Number",
    expirations: "Expiration",
    status: ["Status"],
  };
  const expirationData = [
    {
      typeOfEExpirations: "Driver License ",
      idNumber: "KJH324H323",
      expirations: "22 Jan, 2023",
      status: ["Expired", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "TWIC Card",
      idNumber: "JHG342J4234234J34234",
      expirations: "3 Apr, 2023",
      status: ["Expired", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Passport",
      idNumber: "JB3243JK2",
      expirations: "12 Mar, 2026",
      status: ["Active", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Medical Certificate",
      idNumber: "BH32423",
      expirations: "18 Dec 2028",
      status: ["Active", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Drug & Alcohol Document",
      idNumber: "NIU324HIU32H4U",
      expirations: "15 Oct 2023",
      status: ["Suspended", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Skill Performance Evaluation Certificate",
      idNumber: "BH32J423434",
      expirations: "12 Jan 2030",
      status: ["Suspended", "Claimed", "Claimed"],
    },
  ];
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  return (
    <>
      {/* DriversLicense*/}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle" style={{ marginTop: "0" }}>
            <CardBody>
              <DriversLicense
                handleMenuClick={() => handleMenuClick(0)}
                optionsMenuOpen={activeMenuIndex === 0}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* TWICCard */}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle">
            <CardBody>
              <TWICCard
                handleMenuClick={() => handleMenuClick(1)}
                optionsMenuOpen={activeMenuIndex === 1}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Passport */}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle">
            <CardBody>
              <Passport
                handleMenuClick={() => handleMenuClick(2)}
                optionsMenuOpen={activeMenuIndex === 2}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};
export default Credentials;
